var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_665_5886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6684 30H40.4198C34.6651 30 30 34.6651 30 40.4198V73.6684C30 79.423 34.6651 84.0881 40.4198 84.0881H73.6684C79.423 84.0881 84.0881 79.423 84.0881 73.6684V40.4198C84.0881 34.6651 79.423 30 73.6684 30Z",
    fill: "#52E1F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6684 30H40.4198C34.6651 30 30 34.6651 30 40.4198V73.6684C30 79.423 34.6651 84.0881 40.4198 84.0881H73.6684C79.423 84.0881 84.0881 79.423 84.0881 73.6684V40.4198C84.0881 34.6651 79.423 30 73.6684 30Z",
    fill: "#52E1F2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_665_5886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5355 45.9121H57.2869C51.5323 45.9121 46.8672 50.5772 46.8672 56.3319V89.5805C46.8672 95.3351 51.5323 100 57.2869 100H90.5355C96.2902 100 100.955 95.3351 100.955 89.5805V56.3319C100.955 50.5772 96.2902 45.9121 90.5355 45.9121Z",
    fill: "url(#paint0_linear_665_5886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5355 45.7382H57.2869C51.4362 45.7382 46.6933 50.4812 46.6933 56.3319V89.5805C46.6933 95.4312 51.4362 100.174 57.2869 100.174H90.5355C96.3862 100.174 101.129 95.4312 101.129 89.5805V56.3319C101.129 50.4812 96.3862 45.7382 90.5355 45.7382Z",
    stroke: "url(#paint1_linear_665_5886)",
    strokeWidth: 0.347789
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_665_5886",
    x: 0.0901737,
    y: 0.0901737,
    width: 113.908,
    height: 113.908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.9549,
    result: "effect1_foregroundBlur_665_5886"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_665_5886",
    x: 33.9991,
    y: 33.0441,
    width: 79.8245,
    height: 79.824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.2602
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_665_5886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_665_5886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_665_5886",
    x1: 49.9208,
    y1: 96.9466,
    x2: 97.9017,
    y2: 48.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_665_5886",
    x1: 50.6852,
    y1: 50.166,
    x2: 95.8977,
    y2: 98.5087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchain);
export default __webpack_public_path__ + "static/media/blockchain.52d6530b88d54d1fcfc993977a4464c3.svg";
export { ForwardRef as ReactComponent };